module.exports = __webpack_public_path__ + "img/q_qa.b1fbcdd0.png";